import { render, staticRenderFns } from "./fire-underWriting.vue?vue&type=template&id=21a23f42&scoped=true&"
import script from "./fire-underWriting.vue?vue&type=script&lang=js&"
export * from "./fire-underWriting.vue?vue&type=script&lang=js&"
import style0 from "./fire-underWriting.vue?vue&type=style&index=0&id=21a23f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a23f42",
  null
  
)

export default component.exports